import {ModalController} from '../../../../modules/core/abstracts/controllers/modal-controller';

class PrepareContactPickupModalController extends ModalController {

    constructor($uibModalInstance, contactId, $http, $q, $scope, InvoiceTemplate, SweetAlert, $rootScope, Acl, Alert) {
        super($uibModalInstance);
        this.contactId = contactId;
        this.api = $http;
        this.queue = $q;
        this.scope = $scope;
        this.invoiceTemplatesModel = InvoiceTemplate;
        this.sweetAlert = SweetAlert;
        this.rootScope = $rootScope;
        this.acl = Acl;
        this.alert = Alert;

        this.contact = null;
        this.stepData = {
            1: {
                blockReturnToLastStep: true,
                blockSubmit: false,
                header: 'Create Invoices from Bids',
                submitLabel: 'Create Invoices',
                createdInvoices: [],
                availableBids: [],
                availableTemplates: [],
                currentTemplateId: -1,
                invoiceDate: new Date()
            },
            2: {
                blockReturnToLastStep: true,
                blockSubmit: false,
                header: 'Select invoices to create vouchers for',
                submitLabel: 'Show generation info',
                availableInvoices: []
            },
            3: {
                blockReturnToLastStep: false,
                blockSubmit: false,
                header: 'Voucher and ticket generation information',
                submitLabel: 'Create vouchers and tickets',
                returnToLastStepLabel: 'Change invoices to use',
                generationInformation: {},
                currentTab: -1,
                invoices: [],
                fullInvoices: []
            },
            4: {
                blockReturnToLastStep: true,
                blockSubmit: true,
                header: 'Generated vouchers and tickets',
                submitLabel: '',
                generatedInformation: {},
                shippingInformation: {},
                currentTab: '',
                currentGroupTab: 0,
                printsDone: false
            }
        };

        this.loading = true;
        this.error = false;

        this.currentStep = 1;
        this.currentStepData = null;

        this.loadContact().then(() => {
            this.goToStep(1);
        });
    }

    loadContact() {
        return this.api.get(`contacts/${this.contactId}?include=rsvps`).then((response) => {
            this.contact = response.data.data;
        }, () => {
            this.loading = false;
            this.error = true;
            this.errorMessage = 'Error while getting voucher creation information';
        });
    }

    loadStep1Data() {
        return new Promise((resolve, reject) => {
            const queue = [];
            queue.push(this.api.post(`fp/billing/contacts/${this.contactId}/invoices`, {
                fields: [
                    'id',
                    'invoice_number',
                    'invoice_number_plain',
                    'invoice_date',
                    'sum_after_tax',
                    'address',
                    'status',
                    'shipping_costs',
                    'processing_costs_sum',
                    'rsvps_with_shipping_states',
                    'rsvp_ids'
                ],
                filters: [
                    {
                        'field': 'type',
                        'operator': '=',
                        'value': 'bid'
                    },
                    {
                        'field': 'invoice_date',
                        'operator': '>',
                        'value': (new Date()).getFullYear() + '-01-01'
                    },
                    {
                        'operator': 'group',
                        'filters': [
                            {
                                'field': 'child_invoice_id',
                                'operator': '=',
                                'value': null
                            },
                            {
                                'field': 'child_invoice_type',
                                'boolean': 'or',
                                'operator': '!=',
                                'value': 'invoice'
                            }
                        ]
                    }
                ],
                order: {
                    'invoice_number_plain': 'asc'
                }
            }).then((response) => {
                this.currentStepData.availableBids = _.cloneDeep(response.data.data);
                _.each(this.currentStepData.availableBids, (bid) => {
                    bid.selected = true;
                });

                if (this.stepData[1].availableBids.length === 0) {
                    return this.goToStep(2);
                }

            }));

            queue.push(this.invoiceTemplatesModel.getList().then((collection) => {
                if(this.currentStep !== 1) {
                    return;
                }
                _.forEach(collection, (v, k) => {
                    if (v['enable_for_invoice']) {
                        this.currentStepData.availableTemplates.push(v.plain());
                    }
                });

                // @todo Implement default template setting
                this.currentStepData.currentTemplateId = this.currentStepData.availableTemplates[0].id;
            }));

            this.queue.all(queue).then(() => resolve(), (e) => reject(e));
        });
    }

    loadStep2Data() {
        return this.api.post(`fp/billing/contacts/${this.contactId}/invoices`, {
            fields: [
                'id',
                'invoice_number',
                'invoice_number_plain',
                'invoice_date',
                'sum_after_tax',
                'shipping_costs',
                'processing_costs_sum',
                'rsvp_ids',
                'rsvps_with_shipping_states',
                'status',
                'address'
            ],
            filters: [
                {
                    'field': 'type',
                    'operator': '=',
                    'value': 'invoice'
                },
                {
                    'field': 'has_already_vouchers',
                    'operator': '=',
                    'value': false
                },
                {
                    'operator': 'group',
                    'filters': [
                        {
                            'field': 'status',
                            'operator': '=',
                            'value': 'paid'
                        },
                        {
                            'operator': 'group',
                            'boolean': 'or',
                            'filters': [
                                {
                                    'field': 'status',
                                    'operator': '=',
                                    'value': 'cancelled',
                                    'boolean': 'and'
                                },
                                {
                                    'field': 'has_uncancelled_linked_positions',
                                    'operator': '=',
                                    'value': true
                                },
                            ]
                        },
                    ]
                },
                {
                    'field': 'invoice_date',
                    'operator': '>',
                    'value': (new Date()).getFullYear() + '-01-01'
                },
            ],
            order: {
                'invoice_number_plain': 'asc'
            }
        }).then((response) => {
            this.currentStepData.availableInvoices = response.data.data;

            if (this.currentStepData.availableInvoices.length === 0) {
                this.goToStep(3);
            }
            _.each(this.currentStepData.availableInvoices, (invoice) => {
                invoice.selected = true;
            });
        }, () => {
            console.log('error on step 2');
        });
    }

    loadStep3Data() {
        this.currentStepData.currentTab = -1;
        this.currentStepData.fullInvoices = [];
        const allJobsToWaitFor = [];
        _.each(_.sortBy(this.currentStepData.invoices, (invoice) => {
            return invoice.invoice_number_plain;
        }), (invoice) => {
            if (this.currentStepData.currentTab === -1) {
                this.currentStepData.currentTab = invoice.id;
            }
            allJobsToWaitFor.push(this.api.get(`vouchers/generation-information/invoice/${invoice.id}`).then((response) => {
                this.currentStepData.generationInformation[invoice.id] = response.data.data;
            }));

            allJobsToWaitFor.push(this.api.get(`billing/invoices/${invoice.id}?include=rsvps`).then((response) => {
                this.currentStepData.fullInvoices.push(response.data.data);
            }));
        });

        return this.queue.all(allJobsToWaitFor).then(() => {
            this.loading = false;
            this.scope.$applyAsync();
        }, () => {
            this.loading = false;
        });
    }

    loadStep4Data() {
        this.currentStepData.generatedInformation = {
            tickets: {},
            vouchers: {}
        };
        this.currentStepData.mergedInformation = {};
        this.currentStepData.groupedInvoiceInformation = {};

        const allJobsToWaitFor = [];
        let getInvoiceVoucherPromise = (invoice) => {
            return this.api.post(`vouchers/generate/invoice/${invoice.id}`).then((response) => {
                this.currentStepData.generatedInformation.vouchers[invoice.id] = response.data.data;
            }, () => {
                console.log('error on vouchers');
            })
        };
        let getInvoiceTicketsPromise = (invoice) => {
            return this.api.post(`tickets/create-for-invoice/${invoice.id}`).then((response) => {
                this.currentStepData.generatedInformation.tickets[invoice.id] = response.data.data;
            }, () => {
                console.log('error on vouchers');
            })
        };

        let lastVoucherPromise = null;

        _.each(this.currentStepData.invoices, (invoice) => {
            if (lastVoucherPromise) {
                lastVoucherPromise = lastVoucherPromise.then(() => {
                    return getInvoiceVoucherPromise(invoice);
                });
            } else {
                lastVoucherPromise = getInvoiceVoucherPromise(invoice);
            }

            if(this.acl.hasModule('tickets')) {
                allJobsToWaitFor.push(getInvoiceTicketsPromise(invoice));
            }
        });

        if (lastVoucherPromise) {
            allJobsToWaitFor.push(lastVoucherPromise);
        }

        return this.queue.all(allJobsToWaitFor).then(() => {
            _.each(this.currentStepData.invoices, (invoice) => {
                this.currentStepData.groupedInvoiceInformation[invoice.id] = {};
                if (this.currentStepData.generatedInformation.tickets[invoice.id])
                    _.each(this.currentStepData.generatedInformation.tickets[invoice.id], (ticket) => {
                        const identifier = 'rsvp_' + ticket.rsvp_id;
                        if (!this.currentStepData.groupedInvoiceInformation[invoice.id][identifier]) {
                            this.currentStepData.groupedInvoiceInformation[invoice.id][identifier] = {
                                type: 'rsvp',
                                rsvp: ticket.rsvp,
                                guestlist: ticket.rsvp.guestlist,
                                tickets: [],
                                vouchers: []
                            };
                        }
                        this.currentStepData.groupedInvoiceInformation[invoice.id][identifier].tickets.push(ticket);
                    });

                _.each(this.currentStepData.generatedInformation.vouchers[invoice.id], (voucherGroup) => {
                    const identifier = voucherGroup.type + '_' + voucherGroup[voucherGroup.type].id;
                    if (!this.currentStepData.groupedInvoiceInformation[invoice.id][identifier]) {
                        this.currentStepData.groupedInvoiceInformation[invoice.id][identifier] = {
                            ...voucherGroup,
                            tickets: [],
                            vouchers: []
                        };
                    }

                    _.each(voucherGroup.vouchers, (voucher) => {
                        this.currentStepData.groupedInvoiceInformation[invoice.id][identifier].vouchers.push(voucher);
                    });
                });
            });
            this.loading = false;
            if (this.currentStepData.invoices.length > 0) {
                this.currentStepData.currentTab = this.currentStepData.invoices[0].id;
            }
            this.scope.$applyAsync();
        }, (e) => {
            this.loading = false;
            this.error = true;
            this.errorMessage = 'Error while creating vouchers and tickets';
            this.scope.$applyAsync();
        });
    }

    submitStep1() {
        let getBidToInvoicePromise = (bid, data) => {
                return this.api.post(`billing/invoices/${bid.id}/to-invoice`, data).then((response) => {
                    this.stepData[1].createdInvoices.push(response.data.data);
                }, () => {
                    console.log('error on bid to invoice');
                })
            },
            lastBidToInvoice = new Promise((resolve, reject) => {
                resolve();
            });

        _.each(_.sortBy(this.currentStepData.availableBids, (bid) => {
            return bid.invoice_number_plain;
        }), (bid) => {
            if (bid.selected) {
                if (lastBidToInvoice) {
                    lastBidToInvoice = lastBidToInvoice.then(() => {
                        return getBidToInvoicePromise(bid, {
                            invoice_template_id: this.currentStepData.currentTemplateId,
                            extended: {
                                invoice_date: this.currentStepData.invoiceDate,
                                address: bid.address,
                            }
                        });
                    });
                } else {
                    lastBidToInvoice = getBidToInvoicePromise(bid, {
                        invoice_template_id: this.currentStepData.currentTemplateId,
                        extended: {
                            invoice_date: this.currentStepData.invoiceDate,
                            address: bid.address,
                        }
                    });
                }
            }
        });

        if(!lastBidToInvoice) {
            this.goToStep(2);
            return;
        }

        lastBidToInvoice.then(() => {
            this.goToStep(2);
        }, () => {
            this.loading = false;
            this.error = true;
            this.errorMessage = 'An error occurred while creating invoices for the selected bids';
            this.scope.$applyAsync();
        });
    }

    submitStep2() {
        this.stepData[3].invoices = [];
        _.each(this.currentStepData.availableInvoices, (invoice) => {
            if (invoice.selected) {
                this.stepData[3].invoices.push(invoice);
            }
        });

        if (this.stepData[3].invoices.length === 0) {
            this.sweetAlert.error('Validation', 'Please select at least 1 invoice in minimum');
            this.loading = false;
            return;
        }

        this.goToStep(3);
    }

    submitStep3() {
        this.stepData[4].invoices = this.currentStepData.fullInvoices;

        this.goToStep(4);
    }

    submitStep4() {
        this.stepData[5].blocked_shippings = [];
        _.each(this.currentStepData.shippingInformation, (shipping) => {
            if (!shipping.should_create) {
                this.stepData[5].blocked_shippings.push(shipping.identifier);
            }
        });

        if (this.stepData[5].blocked_shippings.length === this.currentStepData.shippingInformation.length) {
            this.loading = false;
            this.scope.$applyAsync();
            this.sweetAlert.error('No shippings', 'Please select at minimum one shipping to start the process');
            return;
        }

        this.goToStep(5);
    }

    goToStep(newStep) {
        this.loading = true;
        let functionToCall = 'loadStep' + newStep + 'Data';

        if (!this[functionToCall]) {
            this.loading = false;
            this.error = true;
            this.errorMessage = 'Invalid Step provided: ' + newStep;
            return;
        }
        this.currentStep = newStep;
        this.currentStepData = this.stepData[this.currentStep];

        this[functionToCall]().then(() => {
            this.loading = false;
            this.scope.$applyAsync();
        }, (e) => {
            console.log(e);
            this.loading = false;
            this.error = true;
            this.errorMessage = 'Error while loading data for step: ' + newStep;
            this.scope.$applyAsync();
        })
    }

    printDataForShipping(shipping) {
        shipping.already_printed = true;

        this.api.post(`shipping/${shipping.id}/print-documents`).then(() => {
            this.alert.success('Printing', 'The print jobs has been started');
        }, () => {
            this.sweetAlert.error('Error while print', 'Error while printing documents for the shipping');
            shipping.already_printed = false;
            this.scope.$applyAsync();
        });
    }

    sendNoticeForShipping(shipping) {
        shipping.shipping_notice_sent = true;

        this.api.post(`shipping/${shipping.id}/send-notice`).then(() => {
            this.alert.success('Notice queued', 'The shipping notice was queued');
        }, () => {
            this.sweetAlert.error('Error while sending notice', 'Error while sending notice for the shipping');
            shipping.shipping_notice_sent = false;
            this.scope.$applyAsync();
        });
    }

    submitCurrentStep() {
        this.loading = true;
        let functionToCall = 'submitStep' + this.currentStep;

        if (!this[functionToCall]) {
            this.loading = false;
            this.error = true;
            this.errorMessage = 'Can not submit Step: ' + this.currentStep;
            this.scope.$applyAsync();
            return;
        }

        this[functionToCall]();
    }

    returnToLastStep() {
        if (!this.currentStepData.blockReturnToLastStep) {
            this.goToStep(this.currentStep - 1);
        }
    }

    printTakeAwayDocumentsForInvoices(invoices) {
        this.currentStepData.printsDone = true;
        this.api.post(`billing/invoices/print-pickup`, {
            invoices: _.map(invoices, (invoice) => {
               return invoice.id;
            })
        }).then(() => {
            this.currentStepData.printsDone = true;
            this.alert.success('Print started', 'Started to print pickup documents');
        }, (e) => {
            this.currentStepData.printsDone = false;
            console.error(e);
            this.sweetAlert.error('Print error', 'Error while trying to print pickup documents');
        });
    }
}

PrepareContactPickupModalController.$inject = [
    '$uibModalInstance',
    'contactId',
    '$http',
    '$q',
    '$scope',
    'InvoiceTemplate',
    'SweetAlert',
    '$rootScope',
    'Acl',
    'Alert'
];

/**
 * @ngdoc object
 * @name contacts.controller:PrepareContactPickupModalController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .controller('PrepareContactPickupModalController', PrepareContactPickupModalController);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/controllers/contact-actions/prepare-pickup-modal-controller.js